import React from 'react';
import styled from '@benzinga/themetron';
import { SectionTitle } from '@benzinga/core-ui';
import { ContentFeed, ContentFeedProps } from './ContentFeed';
import { NewsListItemElement } from './NewsListItemElement';
import { StoryObject } from '@benzinga/advanced-news-manager';
import DefaultNewsElement from './DefaultNewsElement';
import { PostCardProps } from './PostCard';

export interface NewsListProps extends ContentFeedProps {
  link?: string;
  variant?: 'vertical' | 'horizontal';
  title_case?: boolean;
  postCardProps?: PostCardProps;
  showCommentsIcon?: boolean;
}

export const NewsList: React.FC<NewsListProps> = props => {
  // TODO: Remove after backend implementation;
  if (props.reachContent) {
    props.reachContent.preload = true;
  }

  const newsBlockItem = (node: StoryObject, index: number) => {
    if (props.variant === 'horizontal') {
      return (
        <DefaultNewsElement
          key={`${node.id}-${index}`}
          node={node as StoryObject}
          postCardProps={props.postCardProps}
        />
      );
    }

    return (
      <NewsListItemElement
        contentId={props.contentId}
        key={node.id}
        node={node}
        showCommentsIcon={props.showCommentsIcon}
        showImage={false}
        variant="primary"
      />
    );
  };

  const feedHeader = (title: string) => {
    const titleCase = props?.title_case ?? false;
    return (
      <SectionTitle
        bordered={true}
        className="news-block-title"
        rightSlot={props.link && <span className="see-more">See more</span>}
        titleText={title}
        uppercase={!titleCase}
        url={props.link}
      >
        {title}
      </SectionTitle>
    );
  };

  return (
    <NewsListWrapper className="news-list-wrapper">
      <ContentFeed
        {...props}
        feedHeaderElement={props.feedHeaderElement || feedHeader}
        newsItemElement={newsBlockItem}
      />
    </NewsListWrapper>
  );
};

const NewsListWrapper = styled.div`
  &.news-list-wrapper {
    .news-block {
      border-bottom: ${({ theme }) => `solid 1px ${theme.colorPalette.neutral300}`};
      line-height: ${({ theme }) => theme.lineHeight.normal};
      padding: 12px 0;
      .news-block-headline {
        color: ${({ theme }) => theme.colorPalette.black};
      }
      .article-title {
        font-size: ${({ theme }) => theme.fontSize.lg};
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
      }
    }
    .news-block-title {
      border-color: ${({ theme }) => theme.colorPalette.neutral500};

      .see-more {
        font-size: ${({ theme }) => theme.fontSize.sm};
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
        text-transform: none;
        white-space: nowrap;
      }
    }
    .news-block-list-container {
      display: grid;
      /* gap: 12px; */
    }
    a.news-block-list-headline:hover {
      color: #69a5ff;
    }
  }
`;
